<h2>Ladder Management</h2>

<div *ngIf="message" [style.color]="message.includes('Error') ? 'red' : 'green'" style="margin: 10px 0; font-weight: bold;">
  {{ message }}
</div>

<div style="margin: 20px 0;">
  <button (click)="showAddForm()" [disabled]="busy || showForm" style="padding: 10px 20px; font-size: 16px;">
    Add New Ladder
  </button>
</div>

<div *ngIf="showForm" style="border: 1px solid #ccc; padding: 20px; margin: 20px 0; background-color: #f9f9f9;">
  <h3>{{ isEditMode ? 'Edit Ladder' : 'Add New Ladder' }}</h3>
  
  <form [formGroup]="ladderForm">
    <div style="margin: 10px 0;">
      <label style="display: inline-block; width: 150px;">Ladder ID:</label>
      <input formControlName="ladderId" type="text" style="width: 300px; padding: 5px;" />
      <span *ngIf="ladderForm.get('ladderId')?.hasError('required') && ladderForm.get('ladderId')?.touched" style="color: red; margin-left: 10px;">
        Required
      </span>
      <span *ngIf="ladderForm.get('ladderId')?.hasError('pattern') && ladderForm.get('ladderId')?.touched" style="color: red; margin-left: 10px;">
        Only capital letters, numbers, and dashes allowed
      </span>
    </div>

    <div style="margin: 10px 0;">
      <label style="display: inline-block; width: 150px;">Name:</label>
      <input formControlName="name" type="text" style="width: 300px; padding: 5px;" />
      <span *ngIf="ladderForm.get('name')?.invalid && ladderForm.get('name')?.touched" style="color: red; margin-left: 10px;">
        Required
      </span>
    </div>

    <div style="margin: 10px 0;">
      <label style="display: inline-block; width: 150px;">Start Date:</label>
      <input formControlName="startDate" type="date" style="width: 300px; padding: 5px;" />
      <span *ngIf="ladderForm.get('startDate')?.invalid && ladderForm.get('startDate')?.touched" style="color: red; margin-left: 10px;">
        Required
      </span>
    </div>

    <div style="margin: 10px 0;">
      <label style="display: inline-block; width: 150px;">End Date:</label>
      <input formControlName="endDate" type="date" style="width: 300px; padding: 5px;" />
      <span *ngIf="ladderForm.get('endDate')?.invalid && ladderForm.get('endDate')?.touched" style="color: red; margin-left: 10px;">
        Required
      </span>
    </div>

    <div style="margin: 10px 0;">
      <label style="display: inline-block; width: 150px;">Forfeit Points:</label>
      <select formControlName="forfeitPoints" style="width: 300px; padding: 5px;">
        <option [value]="2">2</option>
        <option [value]="3">3</option>
        <option [value]="4">4</option>
        <option [value]="5">5</option>
      </select>
    </div>

    <div style="margin: 10px 0;">
      <label style="display: inline-block; width: 150px;">Type:</label>
      <select formControlName="type" style="width: 300px; padding: 5px;">
        <option value="Normal">Normal</option>
        <option value="Tiebreak">Tiebreak</option>
        <option value="WaitingRoom">WaitingRoom</option>
      </select>
    </div>

    <div style="margin: 20px 0;">
      <button (click)="saveLadder()" [disabled]="ladderForm.invalid || busy" style="padding: 10px 20px; margin-right: 10px;">
        {{ isEditMode ? 'Update' : 'Create' }}
      </button>
      <button (click)="cancelEdit()" [disabled]="busy" style="padding: 10px 20px;">
        Cancel
      </button>
    </div>
  </form>
</div>

<div *ngIf="busy" style="margin: 20px 0; font-style: italic;">
  Loading...
</div>

<div *ngIf="!busy && ladders.length === 0" style="margin: 20px 0;">
  No ladders found.
</div>

<table *ngIf="!busy && ladders.length > 0" style="width: 100%; border-collapse: collapse; margin: 20px 0;">
  <thead>
    <tr style="background-color: #f0f0f0;">
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">ID</th>
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">Ladder ID</th>
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">Name</th>
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">Start Date</th>
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">End Date</th>
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">Forfeit Points</th>
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">Type</th>
      <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let ladder of ladders">
      <td style="border: 1px solid #ddd; padding: 10px;">{{ ladder.id }}</td>
      <td style="border: 1px solid #ddd; padding: 10px;">{{ ladder.ladderId }}</td>
      <td style="border: 1px solid #ddd; padding: 10px;">{{ ladder.name }}</td>
      <td style="border: 1px solid #ddd; padding: 10px;">{{ formatDate(ladder.startDate) }}</td>
      <td style="border: 1px solid #ddd; padding: 10px;">{{ formatDate(ladder.endDate) }}</td>
      <td style="border: 1px solid #ddd; padding: 10px;">{{ ladder.forfeitPoints }}</td>
      <td style="border: 1px solid #ddd; padding: 10px;">{{ ladder.type }}</td>
      <td style="border: 1px solid #ddd; padding: 10px;">
        <button (click)="editLadder(ladder)" [disabled]="busy || showForm" style="margin-right: 5px; padding: 5px 10px;">
          Edit
        </button>
        <button (click)="deleteLadder(ladder)" [disabled]="busy || showForm" style="padding: 5px 10px; background-color: #dc3545; color: white; border: none; cursor: pointer;">
          Delete
        </button>
      </td>
    </tr>
  </tbody>
</table>

